module.exports = __webpack_public_path__ + "img/logo_europesengage.b3e626de.webp";